module.exports = __webpack_public_path__ + "static/media/S (185).3754bdbd.jpg";